import { render, staticRenderFns } from "./SplideSlide.vue?vue&type=template&id=4435e7e1&"
import script from "./SplideSlide.vue?vue&type=script&lang=js&"
export * from "./SplideSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports